export default __webpack_public_path__ + "static/media/users-green.14f1db7e.svg";